import React, { useState } from 'react';
import { HomePage } from './pages/HomePage';
import { ProductArchivePage } from './pages/ProductArchivePage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { ConfiguratorPage } from './pages/ConfiguratorPage';
import { WarrantyPage } from './pages/WarrantyPage';
import { InstructionsPage } from './pages/InstructionsPage';
import { ContactPage } from './pages/ContactPage';
import { MediaPage } from './pages/MediaPage';
import { DealerLocatorPage } from './pages/DealerLocatorPage';
type PageView = 'home' | 'archive' | 'detail' | 'configurator' | 'warranty' | 'instructions' | 'contact' | 'media' | 'dealers';
export function App() {
  const [currentView, setCurrentView] = useState<PageView>('home');
  const [selectedProductId, setSelectedProductId] = useState<number | undefined>(undefined);
  const handleNavigate = (page: PageView, productId?: number) => {
    setCurrentView(page);
    if (productId) {
      setSelectedProductId(productId);
    }
    window.scrollTo(0, 0);
  };
  return <>
      {currentView === 'home' && <HomePage onNavigate={handleNavigate} data-id="element-0" />}
      {currentView === 'archive' && <ProductArchivePage onNavigate={handleNavigate} data-id="element-1" />}
      {currentView === 'detail' && selectedProductId && <ProductDetailPage productId={selectedProductId} onNavigate={handleNavigate} data-id="element-2" />}
      {currentView === 'configurator' && <ConfiguratorPage onNavigate={handleNavigate} data-id="element-3" />}
      {currentView === 'warranty' && <WarrantyPage onNavigate={handleNavigate} data-id="element-4" />}
      {currentView === 'instructions' && <InstructionsPage onNavigate={handleNavigate} data-id="element-5" />}
      {currentView === 'contact' && <ContactPage onNavigate={handleNavigate} data-id="element-6" />}
      {currentView === 'media' && <MediaPage onNavigate={handleNavigate} data-id="element-7" />}
      {currentView === 'dealers' && <DealerLocatorPage onNavigate={handleNavigate} data-id="element-8" />}
    </>;
}